//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick (handler, link) {
      typeof handler === 'function' && handler()
      link && go(link, this.$router)
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/msg/index.vue